/* 🤖 this file was generated by svg-to-ts */
export const matIconDashboardCustomize: {
  name: 'dashboard-customize';
  data: string;
} = {
  name: 'dashboard-customize',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 11h8V3H3v8zm2-6h4v4H5V5zm8-2v8h8V3h-8zm6 6h-4V5h4v4zM3 21h8v-8H3v8zm2-6h4v4H5v-4zm13-2h-2v3h-3v2h3v3h2v-3h3v-2h-3z"/></svg>`
};
